module.exports = __webpack_public_path__ + "static/media/ic_get_duns.1c718205.svg";